import { cn } from "@/shared/lib/cn";

export interface BrandFootnoteProps {
  className?: string;
}

/**
 * El pie de marca de las pantallas de acceso.
 *
 * Lleva su propio fondo de vidrio porque cae sobre la fotografía, donde el
 * fondo va de claro a casi negro según la pantalla y el alto de la card:
 * con un color de texto fijo sería ilegible en algún caso.
 *
 * El año se calcula al pintar. Escribirlo a mano garantiza que el 1 de
 * enero el sitio anuncie el año pasado y nadie se dé cuenta hasta marzo.
 */
export function BrandFootnote({ className }: BrandFootnoteProps) {
  return (
    <p
      className={cn(
        "w-fit rounded-ds-pill bg-white/45 px-3 py-1 text-[11px] text-ds-ink-3 backdrop-blur-sm",
        className,
      )}
    >
      &copy; {new Date().getFullYear()} It&apos;s The Best
    </p>
  );
}
